var map = {
	"./bananas.jpg": 674,
	"./berries.jpg": 468,
	"./kiwi.jpg": 848,
	"./mango.jpg": 372,
	"./meat.jpg": 86,
	"./milk.jpg": 334,
	"./orange.jpg": 753,
	"./strawberries.jpg": 915
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 958;